import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { JsonPipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../../../shared/components/snackbar/snackbar.component';

@Component({
  selector: 'app-restore-config-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    FontAwesomeModule,
    ClipboardModule,
    JsonPipe,
  ],
  templateUrl: './restore-config-dialog.component.html',
  styleUrl: './restore-config-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RestoreConfigDialogComponent {
  readonly dialogRef = inject(MatDialogRef<RestoreConfigDialogComponent>);

  readonly data = inject<DialogData & { config: object }>(MAT_DIALOG_DATA);

  private snackbar = inject(MatSnackBar);

  onCopied(success: boolean) {
    if (success) {
      this.snackbar.openFromComponent(SnackbarComponent, {
        data: {
          text: 'Copied to clipboard!',
        },
      });
    }
  }

  submit(): void {
    this.dialogRef.close({ download: true });
  }

  close(): void {
    this.dialogRef.close();
  }
}
